import { useContext } from 'react';
import { useTheme } from '@material-ui/core/styles';
import getEnvironmentTheme from '../theme/environmentTheme';

/**
 * Custom hook that provides access to both Material-UI theme and environment theme
 * @returns {Object} Combined theme object with environment info and colors
 */
const useEnvironmentTheme = () => {
  const muiTheme = useTheme();
  const envTheme = getEnvironmentTheme();
  
  return {
    ...muiTheme,
    ...envTheme,
    // Provide easy access to environment-specific colors
    colors: {
      primary: envTheme.primary,
      primaryHover: envTheme.primaryHover,
      primaryDark: envTheme.primaryDark,
      primaryLight: envTheme.primaryLight,
      secondary: envTheme.secondary,
      accent: envTheme.accent,
      accentHover: envTheme.accentHover,
    },
    // Environment flags
    isProduction: envTheme.isProduction,
    isStaging: envTheme.isStaging,
    isDevelopment: envTheme.isDevelopment,
    isLocal: envTheme.isLocal,
    isNgrok: envTheme.isNgrok,
    environment: envTheme.environment,
  };
};

export default useEnvironmentTheme; 